import { render, staticRenderFns } from "./solutionDetails13.vue?vue&type=template&id=51d430b0&scoped=true&"
import script from "./solutionDetails13.vue?vue&type=script&lang=js&"
export * from "./solutionDetails13.vue?vue&type=script&lang=js&"
import style0 from "./solutionDetails13.vue?vue&type=style&index=0&id=51d430b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d430b0",
  null
  
)

export default component.exports